import React from 'react';
import { TextDomain } from '../constants/TextDomain';
import { WPPost } from '../models/WPPost';
import { htmlToText } from '../utils/htmlToText';
import ElementorButton from './ElementorButton';
import css from './PostItem.module.css';

interface PostItemProps {
    post: WPPost;
}

const { __ } = window.wp.i18n;

const PostItem: React.FC<PostItemProps> = (props) => {
    const { post } = props;

    const excerptText = htmlToText(post.excerpt.rendered);
    const descriptionText = excerptText.length > 145 ? excerptText.substring(0, 146) + '...' : excerptText;

    return (
        <div>
            <div className={css.ImageHolder}>
                <img
                    src={post._embedded['wp:featuredmedia'][0].source_url}
                    alt={post._embedded['wp:featuredmedia'][0].alt_text}
                    title={post._embedded['wp:featuredmedia'][0].title.rendered}
                />
            </div>
            <div className={css.TitleHolder}>
                <h3 className={css.Title}>{htmlToText(post.title.rendered)}</h3>
            </div>
            <div className={css.Description}>{descriptionText}</div>
            <div className={css.ButtonHolder}>
                <ElementorButton href={post.link}>{__('Read more', TextDomain)}</ElementorButton>
            </div>
        </div>
    );
};

export default PostItem;
